import { Typography } from '@mui/material'
import { GridSlotsComponentsProps } from '@mui/x-data-grid-premium'
import { useEffect, useState } from 'react'
import { If, Then } from 'react-if'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { cn } from '../../../@/lib/utils'
import { DetailedTable } from '../../tables/types'
import { TableUploadActions } from './TableUploadActions'

export interface TableEmptyStateProps extends NonNullable<
  GridSlotsComponentsProps['noRowsOverlay']
> {
  initialized: boolean
  tableToEdit: DetailedTable
  setOpenTableBulkUploadDialog: (open: boolean) => void
}

/**
 * Component definition for empty state of tables. Used primarily in record details subtables.
 */
export function TableEmptyState({
  initialized,
  tableToEdit,
  setOpenTableBulkUploadDialog,
}: TableEmptyStateProps) {
  const [key, setKey] = useState(0)
  const { t } = useTypedTranslation()

  useEffect(() => {
    // fade-in animation on first render
    setKey((prev) => prev + 1)
  }, [tableToEdit])

  return (
    <If condition={initialized}>
      <Then>
        <div
          className={cn(
            'flex flex-col gap-4 justify-center h-full items-center transition-opacity duration-300 opacity-0',
            key > 0 && 'opacity-100',
          )}
        >
          <Typography>{t('table.no_records')}</Typography>
          <TableUploadActions setOpenTableBulkUploadDialog={setOpenTableBulkUploadDialog} />
        </div>
      </Then>
    </If>
  )
}
